import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ContentUI from '../../widgets/output/ContentUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const AboutPageUI = ({context, about, messageList}) =>
  <PublicPageSF context={context} className='pg_about' backLink='/'
    messageList={messageList} headerMessageKey='c_about'
    centered={!about}
  >
    {
      !about &&
      <SpinnerComponentUI />
    }
    {
      about &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/'
          messageList={messageList} titleMessageKey='c_about'
        />
        <ContentUI context={context} content={about} />
      </div>
    }
  </PublicPageSF>

export default AboutPageUI
